import { useCallback, useRef, useState } from 'react'
import { useEffect } from 'react'
import styles from './ImageSlider.module.css'

interface ImageSliderProps {
    slides: any[]
    transitionDuration?: number
    onSlideChange?: (index: number) => void
}

export const ImageSlider = (props: ImageSliderProps) => {
    const {
        slides,
        transitionDuration = 300,
        onSlideChange
    } = props

    const [currentIndex, setCurrentIndex] = useState(0)
    const [isTransitioning, setIsTransitioning] = useState<boolean>(false)
    const [touchStartX, setTouchStartX] = useState<number>(0)
    const [touchStartY, setTouchStartY] = useState<number>(0)
    const [touchEndX, setTouchEndX] = useState<number>(0)
    const [isDragging, setIsDragging] = useState<boolean>(false)
    const [dragOffset, setDragOffset] = useState<number>(0)
    const sliderRef = useRef<HTMLDivElement>(null)
    const autoPlayRef = useRef<NodeJS.Timeout>()
    const transitionTimeoutRef = useRef<NodeJS.Timeout>()

    const getSlideWidth = useCallback(() => {
        if (!sliderRef.current) {
            return 0
        }

        return sliderRef.current.clientWidth
    }, [])

    const goToPrevious = () => {
        const isFirstSlide = currentIndex === 0;
        const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
        setCurrentIndex(newIndex);
    };

    const goToNext = () => {
        const isLastSlide = currentIndex === slides.length - 1;
        const newIndex = isLastSlide ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex);
    };

  const goToSlide = useCallback((index: number) => {
    if (isTransitioning || index === currentIndex) {
        return
    }
    
    setIsTransitioning(true)
    setCurrentIndex(index)

    onSlideChange?.(index)
    
    if (transitionTimeoutRef.current) {
      clearTimeout(transitionTimeoutRef.current);
    }
    
    transitionTimeoutRef.current = setTimeout(() => {
      setIsTransitioning(false);
    }, transitionDuration);
  }, [
        currentIndex, 
        isTransitioning, 
        onSlideChange, 
        transitionDuration
    ])

    // autosliding 
    //useEffect(() => {
    //    if (slides === undefined) {
    //        return
    //    }

    //    const timer = setTimeout(() => {
    //        goToNext();
    //    }, 5000);
    //    return () => clearTimeout(timer);
    //}, [currentIndex]);

    if (slides === undefined || slides.length === 0) {
        return (
            <></>
        )
    }

    return (
        <div className={styles.ImageSlider__Root}>
            <div className={styles.ImageSlider}>
                <div style={styles1.leftArrow} onClick={goToPrevious}>
                    <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.5 12L1 6.5L6.5 1" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div style={styles1.rightArrow} onClick={goToNext}>
                    <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.5 1L7 6.5L1.5 12" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div className={styles.ImageSlider__Slide} style={{ backgroundImage: `url(${slides[currentIndex].url})` }}>
                    <div style={styles1.slideText}>
                        {/*<h2>{slides[currentIndex].title}</h2>*/}
                       {/* <p>img {currentIndex + 1} from {slides.length}</p>*/}
                    </div>
                </div>
                <div className={styles.ImageSlider__DotsContainer}>
                    {slides.map((slide, slideIndex) => (
                        <div
                            key={slideIndex}
                            style={currentIndex === slideIndex ? styles1.activeDot : styles1.dot}
                            onClick={() => goToSlide(slideIndex)}
                        >
                            ●
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

const styles1: any = {
    slideText: {
        color: 'white',
        fontSize: '24px',
        padding: '20px',
        background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)',
        width: '100%',
        textAlign: 'center'
    },
    leftArrow: {
        position: 'absolute',
        top: '50%',
        transform: 'translate(0, -50%)',
        left: '20px',
        fontSize: '35px',
        color: '#fff',
        zIndex: 1,
        cursor: 'pointer',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        borderRadius: '50%',
        width: '24px',
        height: '24px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'all 0.3s ease',
    },
    rightArrow: {
        position: 'absolute',
        top: '50%',
        transform: 'translate(0, -50%)',
        right: '20px',
        fontSize: '35px',
        color: '#fff',
        zIndex: 1,
        cursor: 'pointer',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        borderRadius: '50%',
        width: '24px',
        height: '24px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'all 0.3s ease',
    },
    dotsContainer: {
        display: 'flex',
        justifyContent: 'center',
        position: 'absolute',
        bottom: '20px',
        width: '100%'
    },
    dot: {
        margin: '0 5px',
        cursor: 'pointer',
        fontSize: '20px',
        color: 'rgba(255, 255, 255, 0.5)',
        transition: 'color 0.3s ease'
    },
    activeDot: {
        margin: '0 5px',
        cursor: 'pointer',
        fontSize: '20px',
        color: '#fff'
    }
};